export default "__VITE_ASSET__CarBLEUO__"